import { DialogTitle, ButtonBase } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

export const DialogTitleWithClose = ({
  onClose,
  children,
  sx,
  buttonProps = {},
  ...dialogProps
}: {
  onClose: () => void;
  children?: React.ReactNode;
  sx?: any;
  buttonProps?: React.ComponentProps<typeof ButtonBase>;
}) => (
  <DialogTitle
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      pr: 4,
      ...sx,
    }}
    {...dialogProps}
  >
    {children}
    <ButtonBase aria-label="close dialog" onClick={onClose} {...buttonProps}>
      <CloseIcon />
    </ButtonBase>
  </DialogTitle>
);

